<sl-titulo>{{ title ?? ("tyc.title" | t) }}</sl-titulo>
<ndc-dynamic [ndcDynamicComponent]="component"></ndc-dynamic>
